export default "__VITE_ASSET__1829b67b__"